import { MouseEvent } from 'react';

import { AnchorButton } from 'components/Button/AnchorButton';
import { Hide } from 'components/Hide/Hide';
import { Icon } from 'components/Icon/Icon';

type Props = {
  isLoggedIn: boolean;
  redirectParam: string;
  onClickLogin: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function PageHeaderMobileLoginButton({
  isLoggedIn,
  redirectParam,
  onClickLogin,
}: Props) {
  if (isLoggedIn) {
    return (
      <AnchorButton href="/logout" size="large" variant="danger">
        {getText('Log Out')}
      </AnchorButton>
    );
  }

  return (
    <AnchorButton
      size="large"
      href={`/login?${redirectParam}`}
      onClick={onClickLogin}
      data-qa-id="login-button-link"
      aria-label={getText('Log In')}
      variant="secondary"
    >
      <Hide lg>{getText('Log In')}</Hide>
      <Hide xs sm md xl>
        <Icon name="person" size={16} />
      </Hide>
    </AnchorButton>
  );
}
